module.exports = __webpack_public_path__ + "static/media/latinad-main.3601e7ca.svg";